import React, { useState } from 'react'
import { OfflineIndicator } from './OfflineIndicator'
import { getLogoVariant } from '../utils/brandUtils'
import logoMain from '../assets/StablePay_Logo.png'

type Page = 'dashboard' | 'payments' | 'settlement-demo' | 'provider-failover' | 'analytics' | 'settings'

interface ProfessionalHeaderProps {
  currentPage?: Page
  onNavigate?: (page: Page) => void
}

export const ProfessionalHeader: React.FC<ProfessionalHeaderProps> = ({ 
  currentPage = 'dashboard', 
  onNavigate 
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const navigation = [
    { name: 'Dashboard', page: 'dashboard' as Page },
    { name: 'Payments', page: 'payments' as Page },
    { name: 'Analytics', page: 'analytics' as Page },
    { name: 'Settings', page: 'settings' as Page },
  ]

  return (
    <header className="professional-header">
      <div className="professional-header__container">
        {/* Logo Section */}
        <div className="professional-header__logo">
          <button 
            onClick={() => onNavigate?.('dashboard')}
            className="professional-header__logo-link"
            style={{ border: 'none', background: 'none', cursor: 'pointer' }}
          >
            <img 
              src={logoMain}
              alt="StablePay Professional Payment Platform" 
              className="professional-header__logo-image professional-logo--header"
              onError={(e) => {
                console.error('Header logo failed to load:', e.currentTarget.src);
                // Just hide the image if it fails to load
                e.currentTarget.style.display = 'none';
              }}
              onLoad={() => console.log('Header logo loaded successfully from assets:', logoMain)}
            />
          </button>
        </div>

        {/* Desktop Navigation */}
        <nav className="professional-header__nav">
          {navigation.map((item) => (
            <button
              key={item.name}
              onClick={() => onNavigate?.(item.page)}
              className={`professional-header__nav-item ${
                currentPage === item.page ? 'professional-header__nav-item--active' : ''
              }`}
              style={{ border: 'none', background: 'none', cursor: 'pointer' }}
            >
              <span>{item.name}</span>
            </button>
          ))}
        </nav>

        {/* Status and User Section */}
        <div className="professional-header__user">
          <OfflineIndicator showDetails={true} className="professional-header__offline" />
          
          <div className="professional-header__user-info">
            <div className="professional-header__user-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 21h18"/>
                <path d="M5 21V7l8-4v18"/>
                <path d="M19 21V11l-6-4"/>
              </svg>
            </div>
            <div className="professional-header__user-details">
              <span className="professional-header__user-name">Demo Business Ltd.</span>
              <span className="professional-header__user-type">Business Account</span>
            </div>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="professional-header__mobile-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          {mobileMenuOpen ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6"/>
              <line x1="3" y1="12" x2="21" y2="12"/>
              <line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      {mobileMenuOpen && (
        <div className="professional-header__mobile-menu">
          <nav className="professional-header__mobile-nav">
            {navigation.map((item) => (
              <button
                key={item.name}
                onClick={() => {
                  onNavigate?.(item.page)
                  setMobileMenuOpen(false)
                }}
                className={`professional-header__mobile-nav-item ${
                  currentPage === item.page ? 'professional-header__nav-item--active' : ''
                }`}
                style={{ border: 'none', background: 'none', cursor: 'pointer', width: '100%', textAlign: 'left' }}
              >
                <span>{item.name}</span>
              </button>
            ))}
          </nav>
          <div className="professional-header__mobile-user">
            <OfflineIndicator className="professional-header__mobile-offline" />
            <div className="professional-header__mobile-user-info">
              <div className="professional-header__user-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 21h18"/>
                  <path d="M5 21V7l8-4v18"/>
                  <path d="M19 21V11l-6-4"/>
                </svg>
              </div>
              <div>
                <div className="professional-header__user-name">Demo Business Ltd.</div>
                <div className="professional-header__user-type">Business Account</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}